import { render, staticRenderFns } from "./fold-btn.vue?vue&type=template&id=73da3d35&scoped=true&"
import script from "./fold-btn.vue?vue&type=script&lang=ts&"
export * from "./fold-btn.vue?vue&type=script&lang=ts&"
import style0 from "./fold-btn.vue?vue&type=style&index=0&id=73da3d35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da3d35",
  null
  
)

export default component.exports